import useInvalidateShop from "./use-invalidate-shop";
import { useApiMutation } from "./use-api-mutation";

type ImageURL =
	| "/shops/{shopId}/preferences/portals/background"
	| "/shops/{shopId}/logo";

export default function useUploadImage(shopId: string, url: ImageURL) {
	const invalidateShop = useInvalidateShop(shopId);

	return useApiMutation("post", url, {
		invalidate: invalidateShop,
		mapVariables: (file: File) => {
			const formData = new FormData();
			formData.append("file", file);
			return {
				params: { path: { shopId: shopId } },
				body: formData as unknown,
			};
		},
	});
}
